import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { from, map, Observable } from 'rxjs';

export enum LANGUAGE_CODES {
    RO = 'ro',
    EN = 'en'
};

export enum COUNTRY_CODES {
    ROMANIA = 'RO',
    UNITED_STATES = 'US'
};

export enum MODULE_PATHS {
    ADMIN = 'admin',
    LOGIN = '_pages/login',
    FORGOT = 'forgot',
    CHANGE = '_pages/change',
    NOT_FOUND = '_pages/not-found',
    ORGANIZER = '_pages/organizer',
    HEADER = 'layout/header',
    CREDITS = 'layout/credits',
    TRAINING = 'training',
    CLIENTS = 'clients'
};

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    constructor(
        private readonly translate: TranslateService,
    ) { }

    public loadTranslations(jsonPath?: string): Observable<boolean> {
        const currentLang = this.translate.currentLang || LANGUAGE_CODES.RO;

        // Use `from` to convert the `import` Promise into an Observable
        const path = jsonPath || MODULE_PATHS.ORGANIZER;
        return from(import(`../${path}/localization/${currentLang}.json`)).pipe(
            map((translations) => {
                this.translate.setTranslation(currentLang, translations.default, true);
                this.translate.use(currentLang);
                this.translate.setDefaultLang(LANGUAGE_CODES.RO);
                return true;
            })
        );
    }

    public switchLanguage(jsonPath: string, lang: string): Observable<boolean> {
        // Use `from` to convert the `import` Promise into an Observable
        this.translate.use(lang);
        return from(import(`../${jsonPath}/localization/${lang}.json`)).pipe(
            map((translations) => {
                this.translate.setTranslation(lang, translations.default, true);
                return true;
            })
        );
    }

    public getLanguage(): string {
        return this.translate.currentLang || this.translate.defaultLang;
    }
}
